import React, { useEffect, useState } from 'react'
import "./ClinicPrescription.css";
import api from '../../../axiosInstance';
import { useApp } from '../../../AppProvider';
import { Preview } from '@mui/icons-material';
import logger from "../../../utils/logger";

const ClinicPrescription = () => {
    const { selectedClinic } = useApp();
    const [previewPdf, setPreviewPdf] = useState(null);
    const [clinicLogo, setClinicLogo] = useState(null);
    const [doctorSignature, setDoctorSignature] = useState(null)
    const [doctorStamp, setDoctorStamp] = useState(null)
    const [selectedFileClinicLogo, setSelectedFileClinicLogo] = useState(null);
    const [selectedFileDoctorSignature, setSelectedFileDoctorSignature] = useState(null);
    const [selectedFileDoctorStamp, setSelectedFileDoctorStamp] = useState(null);

    const handleFileChangeClinicLogo = (event) => {
        const file = event.target.files[0];
        setSelectedFileClinicLogo(file);
        // setPreview(URL.createObjectURL(file));
    };

    const handleFileChangeDoctorSignature = (event) => {
        const file = event.target.files[0];
        setSelectedFileDoctorSignature(file);
    };

    const handleFileChangeDoctorStamp = (event) => {
        const file = event.target.files[0];
        setSelectedFileDoctorStamp(file);
    };

    // ==== GET PREVIEW PDF ======== //
    const getDummyPdfPreview = async () => {
        try {
            // Cache-bust + no-store so the browser never serves a stale cached
            // PDF here — always render the latest /mhr/preview from the server
            // (Postman looks "different" only because it never caches).
            const response = await api.get(`/mhr/preview`, {
                responseType: "blob",
                params: { _t: Date.now() },
                headers: {
                    "Cache-Control": "no-cache, no-store, must-revalidate",
                    Pragma: "no-cache",
                },
            });
            
            const url = URL.createObjectURL(response.data);
            // Swap in the fresh PDF and release the previous blob URL so the
            // iframe always points at the latest /mhr/preview result.
            setPreviewPdf((prev) => {
                if (prev) URL.revokeObjectURL(prev);
                return url;
            });

        } catch (error) {
            logger.error("Error loading PDF:", error);
        }
    };

    useEffect(() => {
        getDummyPdfPreview();
    }, []);


    // ==== GET CLINIC LOGO ======== //
    const getClinicLogo = async () => {
        try {
            const response = await api.get(`/clinics/logo/${selectedClinic._id}`, {
                responseType: "blob",
            }
            );
            const url = URL.createObjectURL(response.data);
            setClinicLogo(url);

        } catch (error) {
            logger.error("Error loading logo:", error);
        }
    };

    useEffect(() => {
        if (selectedClinic?._id) {
            getClinicLogo();
        }
    }, [selectedClinic]);


    // ==== GET DOCTOR SIGNATURE ======== //
    const getDoctorSignature = async () => {
        try {
            const response = await api.get(`/doctors/signature`, {
                responseType: "blob",
            }
            );
            // console.log('respons', response)
            const url = URL.createObjectURL(response.data);
            setDoctorSignature(url);
            // console.log('Signature', url)

        } catch (error) {
            logger.error("Error loading logo:", error);
        }
    };

    useEffect(() => {
        if (selectedClinic?._id) {
            getDoctorSignature();
        }
    }, [selectedClinic]);


    // ==== GET DOCTOR STAMP ======== //
    const getDoctorStamp = async () => {
        try {
            const response = await api.get(`/doctors/stamp`, {
                responseType: "blob",
            }
            );
            const url = URL.createObjectURL(response.data);
            setDoctorStamp(url);

        } catch (error) {
            logger.error("Error loading stamp:", error);
        }
    };

    useEffect(() => {
        if (selectedClinic?._id) {
            getDoctorStamp();
        }
    }, [selectedClinic]);




    // ✅ Upload Clinic Logo API
    const handleUploadClinicLogo = async () => {
        if (!selectedFileClinicLogo) {
            alert("Please select a clinic logo first");
            return;
        }

        const clinicId = selectedClinic._id;
        const formData = new FormData();
        formData.append("logo", selectedFileClinicLogo);
        formData.append("clinicId", clinicId); // ✅ send ID properly

        try {
            const response = await api.post(`/clinics/upload/logo`, formData);

            logger.debug("Clinic Logo Uploaded:", response.data);
            // alert("Clinic logo uploaded successfully");
            await getDummyPdfPreview();
        } catch (error) {
            logger.error(
                "Error uploading clinic logo:",
                error.response?.data || error.message
            );
            alert(
                error.response?.data?.message || "Upload failed"
            );
        }
    };


    const handleUploadDoctorSignature = async () => {
        if (!selectedFileDoctorSignature) {
            alert("Please select a doctor signature first");
            return;
        }

        const clinicId = selectedClinic._id;
        const formData = new FormData();
        formData.append("signature", selectedFileDoctorSignature);
        formData.append("clinicId", clinicId); // ✅ send ID properly

        try {
            const response = await api.post(`/doctors/upload/signature`, formData);

            logger.debug("Doctor Signature Uploaded:", response.data);
            // alert("Doctor signature uploaded successfully");
            await getDummyPdfPreview();
        } catch (error) {
            logger.error(
                "Error uploading doctor signature:",
                error.response?.data || error.message
            );
            alert(
                error.response?.data?.message || "Upload failed"
            );
        }
    };


    const handleUploadDoctorStamp = async () => {
        if (!selectedFileDoctorStamp) {
            alert("Please select a doctor stamp first");
            return;
        }

        const clinicId = selectedClinic._id;
        const formData = new FormData();
        formData.append("file", selectedFileDoctorStamp);
        formData.append("clinicId", clinicId); // ✅ send ID properly

        try {
            const response = await api.post(`/doctors/upload/stamp`, formData);

            logger.debug("Doctor Stamp Uploaded:", response.data);
            // alert("Doctor stamp uploaded successfully");
            await getDummyPdfPreview();
        } catch (error) {
            logger.error(
                "Error uploading doctor stamp:",
                error.response?.data || error.message
            );
            alert(
                error.response?.data?.message || "Upload failed"
            );
        }
    };

    return (
        <div className='clinic-prescription-container'>
            <div className="clinic-prescription-header">
                <div>
                    {/* Clinic Logo Upload */}
                    <div className="upload-box">
                        <label className="upload-label">Clinic Logo</label>
                        <div className="upload-controls">
                            <input type="file" accept="image/*" onChange={handleFileChangeClinicLogo} />
                        </div>
                        <div className='button-container_clinic_prescription'>
                            <button onClick={handleUploadClinicLogo}>Upload Logo</button>
                        </div>
                    </div>
                    <br />
                    <br />
                    <br />
                    {/* Doctor Signature Upload */}
                    <div className="upload-box">
                        <label className="upload-label">Doctor Signature</label>
                        <div className="upload-controls">
                            <input type="file" accept="image/*" onChange={handleFileChangeDoctorSignature} />
                        </div>
                        <div className='button-container_clinic_prescription'>
                            <button onClick={handleUploadDoctorSignature}>Upload Signature</button>
                        </div>
                    </div>
                    <br />
                    <br />
                    <br />
                    {/* Doctor Stamp Upload */}
                    <div className="upload-box">
                        <label className="upload-label">Doctor Stamp</label>
                        <div className="upload-controls">
                            <input type="file" accept="image/*" onChange={handleFileChangeDoctorStamp} />
                        </div>
                        <div className='button-container_clinic_prescription'>
                            <button onClick={handleUploadDoctorStamp}>Upload Stamp</button>
                        </div>
                    </div>
                </div>
                <div className='button-container_clinic_prescription'>
                    {/* <button onClick={PreviewInPdf}>Preview in PDF</button> */}
                </div>
            </div>
            <div className="clinic-prescription-content">
                <h2>Preview Clinic Prescription page</h2>
                <div className='clinic_pdf-preview'>
                    {previewPdf && (
                        <iframe
                            key={previewPdf}
                            className="clinic_pdf-viewer"
                            title="PDF Viewer"
                            src={`${previewPdf}#zoom=70&view=FitH&navpanes=1`}
                            width="100%"
                            height="100%"
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

export default ClinicPrescription
